import React, { useState, useEffect } from 'react';
import './NotificationBanner.css';

const BANNER_STORAGE_KEY = 'flipal-dev-banner-dismissed';

/**
 * Dismissible notification banner for developer job search
 * Appears at the top of the page and remembers dismissal state
 */
function NotificationBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check when the user last dismissed the banner
    const lastDismissedTime = localStorage.getItem(BANNER_STORAGE_KEY);

    if (!lastDismissedTime) {
      // Never dismissed before
      setIsVisible(true);
    } else {
      const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
      const now = new Date().getTime();
      const dismissedTime = parseInt(lastDismissedTime, 10);

      // Show again if it's been more than a week
      if (now - dismissedTime > oneWeekInMs) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    // Store current timestamp
    localStorage.setItem(BANNER_STORAGE_KEY, new Date().getTime().toString());
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="notification-banner">
      <div className="banner-content">
        <div className="banner-message">
          <span className="banner-text">
            Hi, I'm Mike! I'm the developer behind FliPal. Following a layoff in Dec 2025, I'm currently seeking new opportunities in
            <strong> Android Software Development</strong> (contract or full-time remote).
            If you're looking for a seasoned developer, I'd love to chat!
            <span className="banner-links">
              <a href="https://mikedg.com" target="_blank" rel="noopener noreferrer" className="banner-link">Portfolio</a>
              <span className="banner-divider">|</span>
              <a href="https://www.linkedin.com/in/themikedg/" target="_blank" rel="noopener noreferrer" className="banner-link">LinkedIn</a>
              <span className="banner-divider">|</span>
              <a href="mailto:vinblau@gmail.com" className="banner-link">Email</a>
            </span>
          </span>
        </div>
        <button
          className="banner-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          ✕
        </button>
      </div>
    </div >
  );
}

export default NotificationBanner;